import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SEOHead from '../../components/SEO/SEOHead';

export default function ProjectsPage() {
  const { t } = useTranslation();

  const seoData = {
    title: 'پروژه‌های گلخانه سبز آریا - نمونه کارهای موفق ساخت گلخانه در ایران | 50+ پروژه',
    description: 'مشاهده پروژه‌های موفق گلخانه سبز آریا در سراسر ایران. بیش از 50 پروژه ساخت گلخانه‌های هوشمند، مجتمع‌های کشاورزی مدرن و گلخانه‌های تجاری با فناوری پیشرفته.',
    keywords: 'پروژه‌های گلخانه آریا، نمونه کار گلخانه‌سازی، گلخانه‌های ساخته شده، پروژه‌های موفق گلخانه، مجتمع گلخانه‌ای، گلخانه تجاری، گلخانه صنعتی، پروژه‌های کشاورزی، ساخت گلخانه در ایران',
    ogImage: 'https://public.readdy.ai/ai/img_res/2b4ab80969a31e33dcff8592e3f28736.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "پروژه‌های گلخانه سبز آریا",
      "description": "مجموعه پروژه‌های موفق ساخت گلخانه",
      "provider": {
        "@type": "Organization",
        "name": "گلخانه سبز آریا"
      },
      "mainEntity": {
        "@type": "ItemList",
        "name": "پروژه‌های انجام شده",
        "numberOfItems": "50",
        "itemListElement": [
          {
            "@type": "CreativeWork",
            "name": "مجتمع گلخانه‌ای ورامین",
            "description": "ساخت مجتمع گلخانه‌ای 5000 متری با فناوری هوشمند"
          },
          {
            "@type": "CreativeWork",
            "name": "گلخانه هیدروپونیک کرج",
            "description": "طراحی و ساخت گلخانه هیدروپونیک مدرن"
          }
        ]
      }
    }
  };

  const projects = [
    {
      id: 1,
      title: 'گلخانه شیشه‌ای ۵ هکتاری کرج',
      location: 'کرج، البرز',
      area: '۵ هکتار',
      type: 'گلخانه شیشه‌ای',
      crop: 'گوجه فرنگی',
      year: '۱۴۰۲',
      image: 'https://readdy.ai/api/search-image?query=Large%20modern%20glass%20greenhouse%20facility%20tomato%20cultivation%20advanced%20agricultural%20technology%20professional%20farming%20installation%20industrial%20scale%20greenhouse&width=600&height=400&seq=project-1&orientation=landscape&format=webp&quality=85',
      features: [
        'سیستم کنترل اقلیم هوشمند',
        'آبیاری قطره‌ای اتوماتیک',
        'سیستم گرمایش مرکزی',
        'کنترل از راه دور'
      ]
    },
    {
      id: 2,
      title: 'مجتمع گلخانه‌ای اصفهان',
      location: 'اصفهان',
      area: '۳ هکتار',
      type: 'گلخانه پلی‌کربنات',
      crop: 'خیار و فلفل',
      year: '۱۴۰۱',
      image: 'https://readdy.ai/api/search-image?query=Polycarbonate%20greenhouse%20complex%20cucumber%20pepper%20cultivation%20modern%20agricultural%20facility%20professional%20farming%20technology%20Isfahan%20Iran&width=600&height=400&seq=project-2&orientation=landscape&format=webp&quality=85',
      features: [
        'پوشش پلی‌کربنات دوجداره',
        'سیستم تهویه طبیعی',
        'آبیاری فرتیگیشن',
        'کنترل رطوبت اتوماتیک'
      ]
    },
    {
      id: 3,
      title: 'گلخانه تحقیقاتی دانشگاه تهران',
      location: 'کرج، البرز',
      area: '۲۰۰۰ متر مربع',
      type: 'گلخانه تحقیقاتی',
      crop: 'گیاهان دارویی',
      year: '۱۴۰۳',
      image: 'https://readdy.ai/api/search-image?query=Research%20greenhouse%20facility%20university%20medicinal%20plants%20cultivation%20scientific%20agricultural%20research%20modern%20technology%20controlled%20environment&width=600&height=400&seq=project-3&orientation=landscape&format=webp&quality=85',
      features: [
        'سیستم کنترل دقیق محیط',
        'اتاق‌های رشد مجزا',
        'سیستم مانیتورینگ پیشرفته',
        'تجهیزات آزمایشگاهی'
      ]
    },
    {
      id: 4,
      title: 'گلخانه هیدروپونیک شیراز',
      location: 'شیراز، فارس',
      area: '۱ هکتار',
      type: 'گلخانه هیدروپونیک',
      crop: 'سبزیجات برگی',
      year: '۱۴۰۲',
      image: 'https://readdy.ai/api/search-image?query=Hydroponic%20greenhouse%20leafy%20vegetables%20cultivation%20soilless%20farming%20modern%20agricultural%20technology%20vertical%20growing%20systems%20professional%20installation&width=600&height=400&seq=project-4&orientation=landscape&format=webp&quality=85',
      features: [
        'سیستم کشت بدون خاک',
        'محلول غذایی اتوماتیک',
        'سیستم بازیافت آب',
        'کنترل pH و EC'
      ]
    },
    {
      id: 5,
      title: 'گلخانه گل رز مشهد',
      location: 'مشهد، خراسان رضوی',
      area: '۸۰۰۰ متر مربع',
      type: 'گلخانه گل',
      crop: 'گل رز',
      year: '۱۴۰۱',
      image: 'https://readdy.ai/api/search-image?query=Rose%20flower%20greenhouse%20cultivation%20commercial%20flower%20production%20modern%20agricultural%20facility%20professional%20floriculture%20technology%20controlled%20environment&width=600&height=400&seq=project-5&orientation=landscape&format=webp&quality=85',
      features: [
        'سیستم کنترل نور مصنوعی',
        'کنترل دمای دقیق',
        'سیستم CO2',
        'بسته‌بندی اتوماتیک'
      ]
    },
    {
      id: 6,
      title: 'گلخانه ارگانیک تبریز',
      location: 'تبریز، آذربایجان شرقی',
      area: '۱.۵ هکتار',
      type: 'گلخانه ارگانیک',
      crop: 'محصولات ارگانیک',
      year: '۱۴۰۳',
      image: 'https://readdy.ai/api/search-image?query=Organic%20greenhouse%20facility%20sustainable%20agriculture%20natural%20farming%20methods%20eco-friendly%20cultivation%20modern%20technology%20environmental%20protection&width=600&height=400&seq=project-6&orientation=landscape&format=webp&quality=85',
      features: [
        'کشت کاملاً ارگانیک',
        'سیستم کمپوست',
        'کنترل آفات طبیعی',
        'گواهینامه ارگانیک'
      ]
    }
  ];

  const stats = [
    { number: '۵۰+', label: 'پروژه تکمیل شده' },
    { number: '۲۰+', label: 'هکتار گلخانه ساخته شده' },
    { number: '۱۰۰+', label: 'مشتری راضی' },
    { number: '۵', label: 'سال تجربه' }
  ];

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center pt-24 mt-20"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Completed%20greenhouse%20projects%20modern%20glass%20greenhouse%20facilities%20agricultural%20construction%20portfolio%20professional%20farming%20installations&width=1920&height=600&seq=projects-hero&orientation=landscape&format=webp&quality=80')`
        }}
      >
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h1 className="text-5xl lg:text-6xl font-bold mb-6">
            پروژه‌های ما
          </h1>
          <p className="text-xl lg:text-2xl max-w-3xl mx-auto">
            نمونه‌ای از گلخانه‌های ساخته شده توسط تیم ما
          </p>
        </div>
      </section>

      {/* Stats Section - بهبود یافته */}
      <section className="py-20 bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/5 rounded-full blur-2xl animate-pulse"></div>
          <div className="absolute top-1/3 right-16 w-48 h-48 bg-emerald-300/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute bottom-20 left-1/4 w-24 h-24 bg-teal-300/10 rounded-full blur-xl animate-pulse delay-2000"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 bg-cyan-300/10 rounded-full blur-2xl animate-pulse delay-500"></div>
        </div>

        {/* Grid Pattern Overlay */}
        <div className="absolute inset-0 opacity-5">
          <div className="w-full h-full" style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, white 1px, transparent 0)`,
            backgroundSize: '40px 40px'
          }}></div>
        </div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 drop-shadow-lg">
              دستاوردهای ما در یک نگاه
            </h2>
            <p className="text-xl text-emerald-100 max-w-3xl mx-auto leading-relaxed">
              با بیش از یک دهه تجربه، افتخار همکاری با بهترین کشاورزان کشور را داشته‌ایم
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {/* پروژه تکمیل شده */}
            <div className="group text-center text-white transform hover:scale-105 transition-all duration-500">
              <div className="relative">
                <div className="w-24 h-24 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-6 border border-white/20 shadow-2xl group-hover:shadow-emerald-300/25 transition-all duration-500">
                  <i className="ri-building-2-line text-4xl text-white group-hover:scale-110 transition-transform duration-300"></i>
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-pulse"></div>
              </div>
              
              <div className="relative">
                <div className="text-5xl lg:text-6xl font-bold mb-3 bg-gradient-to-r from-white via-emerald-100 to-teal-100 bg-clip-text text-transparent drop-shadow-2xl">
                  ۵۰+
                </div>
                <div className="absolute inset-0 text-5xl lg:text-6xl font-bold text-white/10 blur-sm">
                  ۵۰+
                </div>
              </div>
              
              <div className="text-lg lg:text-xl text-emerald-100 font-semibold mb-2">
                پروژه تکمیل شده
              </div>
              <div className="text-sm text-emerald-200/80 leading-relaxed">
                در سراسر کشور با کیفیت بالا
              </div>
              
              {/* Progress Bar */}
              <div className="mt-4 w-full bg-white/20 rounded-full h-2 overflow-hidden">
                <div className="h-full bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full animate-pulse" style={{ width: '85%' }}></div>
              </div>
            </div>

            {/* هکتار گلخانه */}
            <div className="group text-center text-white transform hover:scale-105 transition-all duration-500">
              <div className="relative">
                <div className="w-24 h-24 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-6 border border-white/20 shadow-2xl group-hover:shadow-teal-300/25 transition-all duration-500">
                  <i className="ri-landscape-line text-4xl text-white group-hover:scale-110 transition-transform duration-300"></i>
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-green-400 to-emerald-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-pulse"></div>
              </div>
              
              <div className="relative">
                <div className="text-5xl lg:text-6xl font-bold mb-3 bg-gradient-to-r from-white via-teal-100 to-cyan-100 bg-clip-text text-transparent drop-shadow-2xl">
                  ۲۰+
                </div>
                <div className="absolute inset-0 text-5xl lg:text-6xl font-bold text-white/10 blur-sm">
                  ۲۰+
                </div>
              </div>
              
              <div className="text-lg lg:text-xl text-teal-100 font-semibold mb-2">
                هکتار گلخانه ساخته شده
              </div>
              <div className="text-sm text-teal-200/80 leading-relaxed">
                با تکنولوژی هلندی پیشرفته
              </div>
              
              {/* Progress Bar */}
              <div className="mt-4 w-full bg-white/20 rounded-full h-2 overflow-hidden">
                <div className="h-full bg-gradient-to-r from-green-400 to-emerald-400 rounded-full animate-pulse" style={{ width: '70%' }}></div>
              </div>
            </div>

            {/* مشتری راضی */}
            <div className="group text-center text-white transform hover:scale-105 transition-all duration-500">
              <div className="relative">
                <div className="w-24 h-24 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-6 border border-white/20 shadow-2xl group-hover:shadow-cyan-300/25 transition-all duration-500">
                  <i className="ri-user-smile-line text-4xl text-white group-hover:scale-110 transition-transform duration-300"></i>
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-blue-400 to-cyan-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-pulse"></div>
              </div>
              
              <div className="relative">
                <div className="text-5xl lg:text-6xl font-bold mb-3 bg-gradient-to-r from-white via-cyan-100 to-blue-100 bg-clip-text text-transparent drop-shadow-2xl">
                  ۱۰۰+
                </div>
                <div className="absolute inset-0 text-5xl lg:text-6xl font-bold text-white/10 blur-sm">
                  ۱۰۰+
                </div>
              </div>
              
              <div className="text-lg lg:text-xl text-cyan-100 font-semibold mb-2">
                مشتری راضی
              </div>
              <div className="text-sm text-cyan-200/80 leading-relaxed">
                با رضایت ۹۸٪ از خدمات ما
              </div>
              
              {/* Progress Bar */}
              <div className="mt-4 w-full bg-white/20 rounded-full h-2 overflow-hidden">
                <div className="h-full bg-gradient-to-r from-blue-400 to-cyan-400 rounded-full animate-pulse" style={{ width: '98%' }}></div>
              </div>
            </div>

            {/* سال تجربه */}
            <div className="group text-center text-white transform hover:scale-105 transition-all duration-500">
              <div className="relative">
                <div className="w-24 h-24 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-6 border border-white/20 shadow-2xl group-hover:shadow-purple-300/25 transition-all duration-500">
                  <i className="ri-time-line text-4xl text-white group-hover:scale-110 transition-transform duration-300"></i>
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-pulse"></div>
              </div>
              
              <div className="relative">
                <div className="text-5xl lg:text-6xl font-bold mb-3 bg-gradient-to-r from-white via-purple-100 to-pink-100 bg-clip-text text-transparent drop-shadow-2xl">
                  ۱۵+
                </div>
                <div className="absolute inset-0 text-5xl lg:text-6xl font-bold text-white/10 blur-sm">
                  ۱۵+
                </div>
              </div>
              
              <div className="text-lg lg:text-xl text-purple-100 font-semibold mb-2">
                سال تجربه
              </div>
              <div className="text-sm text-purple-200/80 leading-relaxed">
                در صنعت گلخانه‌سازی ایران
              </div>
              
              {/* Progress Bar */}
              <div className="mt-4 w-full bg-white/20 rounded-full h-2 overflow-hidden">
                <div className="h-full bg-gradient-to-r from-purple-400 to-pink-400 rounded-full animate-pulse" style={{ width: '90%' }}></div>
              </div>
            </div>
          </div>

          {/* Bottom Achievement Banner */}
          <div className="mt-16 text-center">
            <div className="inline-flex items-center space-x-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-8 py-4 shadow-2xl">
              <div className="flex items-center space-x-2">
                <i className="ri-award-line text-2xl text-yellow-300"></i>
                <span className="text-white font-semibold">برترین شرکت گلخانه‌سازی ۲۰۲۳</span>
              </div>
              <div className="w-px h-6 bg-white/30"></div>
              <div className="flex items-center space-x-2">
                <i className="ri-shield-check-line text-2xl text-green-300"></i>
                <span className="text-white font-semibold">تضمین کیفیت ۱۰ ساله</span>
              </div>
              <div className="w-px h-6 bg-white/30"></div>
              <div className="flex items-center space-x-2">
                <i className="ri-customer-service-2-line text-2xl text-blue-300"></i>
                <span className="text-white font-semibold">پشتیبانی ۲۴/۷</span>
              </div>
            </div>
          </div>
        </div>

        {/* Floating Animation Elements */}
        <div className="absolute top-1/4 left-1/4 w-4 h-4 bg-white/30 rounded-full animate-ping delay-1000"></div>
        <div className="absolute top-1/2 right-1/3 w-3 h-3 bg-emerald-300/40 rounded-full animate-ping delay-2000"></div>
        <div className="absolute bottom-1/3 left-1/2 w-5 h-5 bg-teal-300/30 rounded-full animate-ping delay-3000"></div>
      </section>

      {/* Projects Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              پروژه‌های انجام شده
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              مجموعه‌ای از گلخانه‌های موفق که توسط تیم ما طراحی و ساخته شده‌اند
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project) => (
              <div key={project.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="relative h-64">
                  <img 
                    src={project.image}
                    alt={project.title}
                    className="w-full h-64 object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-bold">
                    {project.year}
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-3">
                    {project.title}
                  </h3>
                  
                  <div className="space-y-2 mb-4">
                    <div className="flex items-center text-gray-600">
                      <i className="ri-map-pin-line ml-2 text-green-600"></i>
                      {project.location}
                    </div>
                    <div className="flex items-center text-gray-600">
                      <i className="ri-ruler-line ml-2 text-green-600"></i>
                      {project.area}
                    </div>
                    <div className="flex items-center text-gray-600">
                      <i className="ri-building-line ml-2 text-green-600"></i>
                      {project.type}
                    </div>
                    <div className="flex items-center text-gray-600">
                      <i className="ri-plant-line ml-2 text-green-600"></i>
                      {project.crop}
                    </div>
                  </div>

                  <div className="border-t pt-4">
                    <h4 className="font-bold text-gray-800 mb-2">ویژگی‌ها:</h4>
                    <ul className="space-y-1">
                      {project.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center text-sm text-gray-600">
                          <i className="ri-check-line text-green-600 ml-2"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            پروژه بعدی شما
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            آماده‌اید تا گلخانه رویایی خود را با ما بسازید؟
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/contact" className="bg-green-600 text-white px-8 py-4 rounded-lg font-bold hover:bg-green-700 transition-colors whitespace-nowrap">
              مشاوره رایگان
            </a>
            <a href="/services" className="border-2 border-green-600 text-green-600 px-8 py-4 rounded-lg font-bold hover:bg-green-600 hover:text-white transition-colors whitespace-nowrap">
              مشاهده خدمات
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
